import { formatNum } from '@app/utils/math';

type Props = {
  x?: string | number;
  y?: string | number;
  value?: string | number;
  positionBelow?: boolean;
};

const toNumber = (value: string | number | undefined): number | null => {
  if (typeof value === 'number') return value;

  if (typeof value === 'string') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
};

export const CustomMonthlyLabel = ({ x, y, value, positionBelow = false }: Props) => {
  const valueNumber = toNumber(value);
  const xNumber = toNumber(x);
  const yNumber = toNumber(y);

  if (valueNumber === null || xNumber === null || yNumber === null) return null;
  if (valueNumber === 0) return null;

  const formattedValue = formatNum(valueNumber, 0, 0);
  const text = `${formattedValue} Ph`;
  const paddingX = 8;
  const charWidth = 6;
  const width = text.length * charWidth + paddingX * 2;
  const height = 20;
  
  const rectY = positionBelow ? yNumber + 8 : yNumber - height - 8;
  const textY = positionBelow ? yNumber + height / 2 + 7 : yNumber - height / 2 - 7;

  return (
    <g>
      <rect
        x={xNumber - width / 2}
        y={rectY}
        width={width}
        height={height}
        rx={8}
        fill="#FFFFFF"
        stroke="#000"
        strokeWidth={1}
      />
      <text
        x={xNumber}
        y={textY}
        textAnchor="middle"
        fill="#000"
        fontSize={10}
        fontWeight={600}
        fontFamily="Inter"
        dominantBaseline="middle"
      >
        {text}
      </text>
    </g>
  );
};